import React, { useState } from 'react'
import { actionsList } from '../../assets/data/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import styles from './Actions.module.css'



const Actions = ({rightPanelActiveComponent, toggleRightPanelComponent}: any) => {

    const [areas, setAreas] = useState(actionsList)
    const [selectedAreaIndex, setSelectedAreaIndex] = useState<any>()

    const onAreaSelectHandler = (areaIndex: number) => {
        setSelectedAreaIndex(areaIndex)
    }

    const areasUI = areas.map((area, i) => {
        return  <li className={`${styles.areaContainer} p-3 mb-2`} onClick={() => onAreaSelectHandler(i)} key={area.uuid}>
                    <h5>{area.title}</h5>
                </li>
    })

    const toggleAsset = (assetIndex: number) => {
        let list: any = [...areas]
        list[selectedAreaIndex].assets[assetIndex].selected = !list[selectedAreaIndex].assets[assetIndex].selected
        setAreas(list)
    }

    const actionsUI = areas[selectedAreaIndex] && areas[selectedAreaIndex].assets && areas[selectedAreaIndex].assets.map((asset, i) => {
        return  <li key={i}>
                    <div className={`${styles.assetContainer} d-flex mb-2 justify-content-between align-items-center`}>
                        <div className="d-flex">
                            <div className={styles.assetIcon}></div>
                            <a href={asset.link} target="_blank" rel="noreferrer" className={`${styles.assetDetails} p-3 text-decoration-none`}>
                                <h5 className="m-0">{asset.title}</h5>
                                <p className="m-0">{asset.description}</p>
                            </a>
                        </div>
                        <input 
                            className="me-3"
                            type="checkbox"
                            name={`${areas[selectedAreaIndex].uuid}-${i}`}
                            onClick={() => toggleAsset(i)} 
                            checked={asset.selected ? true : false}
                        />
                    </div>
                </li>
    })

    return (
        <div className={styles.actionsContainer} hidden={rightPanelActiveComponent === 'actions' ? false : true }>
            {
                selectedAreaIndex > -1 ?
                    <div className={`d-flex align-items-center mt-0 mb-2 ${styles.scoreCardHeader}`}>
                        <button title="Back" onClick={() => setSelectedAreaIndex(undefined)} className="mt-0 back-arrow btn">
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <h5 className={styles.containerTitle}>{areas[selectedAreaIndex].title}</h5>
                    </div> :
                    <div className={`d-flex justify-content-between mb-2 ${styles.scoreCardHeader}`}>
                        <h5 className={styles.containerTitle}>Actions</h5>
                        <span onClick={() => toggleRightPanelComponent()}><i className="bi bi-x-square fs-5"></i></span>
                    </div>
            }
            <div>
                <p className={`${styles.description} p-3`}>Based on the key moments and data, the system has auto recommended areas of improvement.</p>
                
                    { 
                        (selectedAreaIndex > -1) ? 
                            <div>
                                <ul className="list-unstyled mb-5">{actionsUI}</ul>
                                <div className={styles.saveContainer}>
                                    <button type="button" onClick={() => setSelectedAreaIndex(undefined)} className={`btn btn-primary `}>Save</button>
                                </div>
                            </div>: 
                            <ul className="list-unstyled">{areasUI}</ul>
                    }
            </div>            
        </div>
    )
}

export default Actions
